/**
2  *  Copyright (c) 2018 Micro Focus Software Inc.  All Rights Reserved.
3  *
4  * THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
5  * AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
6  * WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
7  * TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
8  * AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
9  * INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
10  * PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
11  * CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
12  * OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
13  * ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
14  * THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
15  */


import { Component, ViewEncapsulation, AfterViewInit, OnDestroy, OnInit, AfterViewChecked, HostListener } from '@angular/core';
import { StoreItemsService } from '../services/storeitems.service';
import { StoreCategoriesResponse, StoreCategoriesResultEntity } from '../model/storecategoriesresponse';
import { StoreItemFilterInfo } from '../model/storeitemfilterinfo';
import { StoreCapableItemTypesResultEntity, StoreCapableItemTypesResponse } from '../model/storecapableitemtypesresponse';
import { Subscription } from 'rxjs';
import { CheckedUncheckedPipe } from '../../shared/pipes/checkedUnchecked.pipe';
import { NavigationExtras, Router, ActivatedRoute } from '@angular/router';
import { PlatformLocation } from '@angular/common';
import { CommonConstants } from '../../../../common/constants/common-constants';
declare var $: any;

@Component({
  selector: 'zsd-storefilter',
  templateUrl: '../view/storefilter.component.html',
  providers: [
    CheckedUncheckedPipe
  ],
  encapsulation: ViewEncapsulation.None
})

export class StoreFilterComponent implements AfterViewInit, OnDestroy, OnInit, AfterViewChecked {
  static searchString = null;
  static selectedCategories = null;
  static selectedItemTypes = null;
  static myRequested = null;
  categoryResults = new Array<StoreCategoriesResultEntity>();
  storeCapableItemTypesResults = new Array<StoreCapableItemTypesResultEntity>();
  isRequestedItems = '';
  searchCategory;
  searchItemType: string;
  storeItemFilterInfo: StoreItemFilterInfo = new StoreItemFilterInfo();
  searchSubscription: Subscription;
  windowSize;
  isFilterOpen: boolean;
  categorizationChecked = false;
  itemTypeChecked = false;

  constructor(private storeitemsservice: StoreItemsService,
    private checkedUncheckedPipe: CheckedUncheckedPipe, private router: Router, private route: ActivatedRoute,
    private location: PlatformLocation) {
    this.windowSize = window.innerWidth;
    // AOT Changes
    this.location.onPopState(() => {
      this.ngOnInit();
    });
    // AOT Changes
    this.location.onHashChange(() => {
      this.ngOnInit();
    });
  }

  ngOnInit() {
    this.initFilter();
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    // a hack to fix filter display issue when protrait and landscape mode has mobile and desktop layout respectively.
  }

  initFilter() {
    this.initializeParameters();
    let categoryIds = new Array<number>();
    let itemTypeIds = new Array<number>();
    this.route.queryParams.subscribe(params => {
      if (params['searchTerm']) {
        this.storeItemFilterInfo.searchTerm = JSON.parse(params['searchTerm']);
      }
      if (params['myRequested']) {
        this.storeItemFilterInfo.myRequested = JSON.parse(params['myRequested']);
      }
      if (params['storeCategories']) {
        categoryIds = JSON.parse(params['storeCategories']);
        if (categoryIds.length > 0) {
          this.categorizationChecked = true;
        }
      }
      if (params['storeCapableItemTypes']) {
        itemTypeIds = JSON.parse(params['storeCapableItemTypes']);
        if (itemTypeIds.length > 0) {
          this.itemTypeChecked = true;
        }
      }
    });

    if (this.storeItemFilterInfo.searchTerm !== null) {
      StoreFilterComponent.searchString = this.storeItemFilterInfo.searchTerm.toString();
    }
    if (this.storeItemFilterInfo.myRequested === null) {
      this.isRequestedItems = 'all_items';
    } else if (this.storeItemFilterInfo.myRequested) {
      this.isRequestedItems = 'my_requested_items';
    } else {
      this.isRequestedItems = 'non_requested_items';
    }

    this.getStoreCategories(categoryIds);
    this.getStoreCapableItemtypes(itemTypeIds);
    this.onChecked();


  }
  initializeParameters() {
      StoreFilterComponent.selectedCategories = null;
      StoreFilterComponent.selectedItemTypes = null;
      StoreFilterComponent.myRequested = null;
      this.getStoreCategories([]);
      this.getStoreCapableItemtypes([]);
      StoreFilterComponent.searchString = null;
      this.storeItemFilterInfo.myRequested = null; // adding so that intially both should be selected
      this.storeItemFilterInfo.searchTerm = null;
  }


  ngAfterViewChecked() {
    this.windowSize = window.innerWidth;
  }

  closeFilter() {
    this.isFilterOpen = false;
    $('#storefiltermenu').width('0');
    $('body').css('overflow-y', 'auto');
  }

  getStoreCategories(categoryIds: Array<number>) {
    this.storeitemsservice.getStoreCategories().subscribe(
      (categoryResponse: StoreCategoriesResponse) => {
        this.categoryResults = categoryResponse.results;

        for (let i = 0; i < categoryIds.length; i++) {
          for (let j = 0; j < this.categoryResults.length; j++) {
            if (this.categoryResults[j].storeCategoryId === categoryIds[i]) {
              this.categoryResults[j].checked = true;
            }
          }
        }
        this.categoryResults = this.checkedUncheckedPipe.transform(this.categoryResults, 'storeCategoryName');
      });
  }

  getStoreCapableItemtypes(itemTypeIds: Array<number>) {
    this.storeitemsservice.getStoreCapableItemTypes().subscribe(
      (storeCapableItemTypesResponse: StoreCapableItemTypesResponse) => {
        this.storeCapableItemTypesResults = storeCapableItemTypesResponse.results;

        for (let i = 0; i < itemTypeIds.length; i++) {
          for (let j = 0; j < this.storeCapableItemTypesResults.length; j++) {
            if (this.storeCapableItemTypesResults[j].itemTypeId === itemTypeIds[i]) {
              this.storeCapableItemTypesResults[j].checked = true;
            }
          }
        }
        this.storeCapableItemTypesResults = this.checkedUncheckedPipe.transform(this.storeCapableItemTypesResults, 'itemTypename');
      });
   }
   // if items or categories are checked, categories/items should be expanded
   onChecked() {
      if (this.categorizationChecked) {
        console.log('category is checked');
       $('#sd_categorization').collapse('show');
      }
      if (this.itemTypeChecked) {
        $('#sd_item_types').collapse('show');
      }
    }
  applyFilter() {
    if (this.isRequestedItems === 'my_requested_items') {
      StoreFilterComponent.myRequested = JSON.stringify(true);
    } else if (this.isRequestedItems === 'non_requested_items') {
      StoreFilterComponent.myRequested = JSON.stringify(false);
    } else {
      StoreFilterComponent.myRequested = null;
    }
    this.storeItemFilterInfo.storeCategories = this.categoryResults.filter(category => category.checked === true);
    this.storeItemFilterInfo.storeCapableItemTypes = this.storeCapableItemTypesResults.filter(itemType => itemType.checked === true);

    let categoryIds = new Array<number>();
    for (let i = 0; i < this.storeItemFilterInfo.storeCategories.length; i++) {
      categoryIds[i] = this.storeItemFilterInfo.storeCategories[i].storeCategoryId;
    }

    let itemTypeIds = new Array<number>();
    for (let i = 0; i < this.storeItemFilterInfo.storeCapableItemTypes.length; i++) {
      itemTypeIds[i] = this.storeItemFilterInfo.storeCapableItemTypes[i].itemTypeId;
    }

    if (StoreFilterComponent.searchString !== null) {
      StoreFilterComponent.searchString = JSON.stringify(StoreFilterComponent.searchString);
    }
    if (categoryIds.length > 0) {
      StoreFilterComponent.selectedCategories = JSON.stringify(categoryIds);
    }
    if (itemTypeIds.length > 0) {
      StoreFilterComponent.selectedItemTypes = JSON.stringify(itemTypeIds);
    }

    let navigationExtras: NavigationExtras = {
      queryParams: {
        'searchTerm': StoreFilterComponent.searchString,
        'myRequested': StoreFilterComponent.myRequested,
        'storeCategories': StoreFilterComponent.selectedCategories,
        'storeCapableItemTypes': StoreFilterComponent.selectedItemTypes
      },
      queryParamsHandling: 'merge'
    };

    this.router.navigateByUrl('/my-profile', { skipLocationChange: true }).then(() =>
      this.router.navigate([CommonConstants.STORE_COMPONENT], navigationExtras ));

    this.closeFilter();
  }

  // will be called on click of clear button
  clearFilter() {
    this.resetFilter();
    if (StoreFilterComponent.searchString !== null) {
      StoreFilterComponent.searchString = JSON.stringify(StoreFilterComponent.searchString);
    }
    let navigationExtras: NavigationExtras = {
      queryParams: {
        'searchTerm': StoreFilterComponent.searchString,
      },
      queryParamsHandling: 'merge'
    };
    this.router.navigateByUrl('/my-profile', { skipLocationChange: true }).then(() =>
      this.router.navigate([CommonConstants.STORE_COMPONENT], navigationExtras ));

    this.closeFilter();
  }

  // will reset the selected filter values
  resetFilter() {
    StoreFilterComponent.selectedCategories = null;
    StoreFilterComponent.selectedItemTypes = null;
    StoreFilterComponent.myRequested = null;
    this.isRequestedItems = 'all_items';
    this.searchCategory = '';
    this.searchItemType = '';
    this.categoryResults.forEach(category => category.checked = false);
    this.storeCapableItemTypesResults.forEach(itemType => itemType.checked = false);
  }

  ngAfterViewInit() {
    $(document).ready(function () {
      $('[data-toggle=popover]').popover();
    });
  }


  ngOnDestroy() {
  }
}
